import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as express from "express";
import * as passport from "passport";
import * as session from "express-session";
import * as docusign from "docusign-esign";
import * as moment from "moment";
import * as fs from "fs-extra";
import * as path from "path";
// import * as promisify from "util";

@Injectable()
export class DocusignProvider {
  // app = express();
  // port = process.env.PORT || 3000;
  // host = process.env.HOST || "localhost";
  // hostUrl = "http://" + this.host + ":" + this.port;
  // clientID = process.env.DS_CLIENT_ID || "9174cd97-598e-4a42-8265-d0814ae4c2eb";
  // clientSecret =
  //   process.env.DS_CLIENT_SECRET || "5d5b5184-bdfb-408f-8771-d842f4187d05";
  // signerEmail = process.env.DS_SIGNER_EMAIL || "alanguo1999@gmail.com";
  // signerName = process.env.DS_SIGNER_NAME || "alanguo1999@gmail.com";
  // templateId =
  //   process.env.DS_TEMPLATE_ID || "7a243db0-77be-49f6-9512-baae62d5b8ce";
  // baseUriSuffix = "/restapi";
  // testDocumentPath = "../demo_documents/test.pdf";
  // test2DocumentPath = "../demo_documents/battle_plan.docx";
  apiClient: any;
  accountId: any;
  baseUri: any;
  eg: any;

  constructor(public http: HttpClient) {
    // passport.use(
    //   new docusign.OAuthClient(
    //     {
    //       sandbox: true,
    //       clientID: this.clientID,
    //       clientSecret: this.clientSecret,
    //       callbackURL: this.hostUrl + "/auth/callback",
    //       state: true // automatic CSRF protection.
    //       // See https://github.com/jaredhanson/passport-oauth2/blob/master/lib/state/session.js
    //     },
    //     function(accessToken, refreshToken, params, user, done) {
    //       // The params arg will be passed additional parameters of the grant.
    //       // See https://github.com/jaredhanson/passport-oauth2/pull/84
    //       //
    //       // Here we're just assigning the tokens to the user profile object but we
    //       // could be using session storage or any other form of transient-ish storage
    //       user.accessToken = accessToken;
    //       user.refreshToken = refreshToken;
    //       user.expiresIn = params.expires_in;
    //       // Calculate the time that the token will expire
    //       user.expires = moment().add(user.expiresIn, "s");
    //       return done(null, user);
    //     }
    //   )
    // );

//     passport.serializeUser(function(user, done) {
//       done(null, user);
//     });
//     passport.deserializeUser(function(obj, done) {
//       done(null, obj);
//     });

//     // Configure the webserver
//     this.app
//       .use(
//         session({
//           secret: "secret token",
//           resave: true,
//           saveUninitialized: true
//         })
//       )
//       .use(passport.initialize())
//       .use(passport.session())
//       /* Home page */
//       .get("/", function(req, res) {
//         res.send(`<h2>Home page</h2>
// <h3><a href="/go?eg=1">Send Envelope via email</a></h3>
// <h3><a href="/go?eg=2">Embeddded Signing Ceremony</a></h3>
// <h3><a href="/go?eg=3">Send envelope using a template</a></h3>
// <h3><a href="/go?eg=4">Embedded Sending</a></h3>
// <h3><a href="/go?eg=5">Embedded DocuSign console</a></h3>
// <h3><a href="/go?eg=6">List multiple envelopes' status</a></h3>
// <h3><a href="/go?eg=7">Get an envelope's status</a></h3>
// <h3><a href="/go?eg=8">List an envelope's recipients</a></h3>
// <h3><a href="/go?eg=9">Download an envelope's document(s)</a></h3>
// `);
//       })
//       /* Page for starting OAuth Authorization Code Grant */
//       .get("/auth", function(req, res, next) {
//         passport.authenticate("docusign")(req, res, next);
//       })
//       /* Page for handling OAuth Authorization Code Grant callback */
//       .get("/auth/callback", [this.dsLoginCB1, this.dsLoginCB2])
//       /* Page to receive pings from the DocuSign embedded Signing Ceremony */
//       .get("/dsping", this.dsPingController)
//       /* Middleware: ensure that we have a DocuSign token. Obtain one if not. */
//       /*             checkToken will apply to all subsequent routes. */
//       .use(this.checkToken)
//       /* Page to execute an example */
//       .get("/go", this.goPageController);

//     /* Start the web server */
//     if (this.clientID === "{CLIENT_ID}") {
//       console.log(
//         `PROBLEM: You need to set the Client_ID (Integrator Key), and perhaps other settings as well. You can set them in the source or set environment variables.`
//       );
//     } else {
//       this.app.listen(Number(this.port), this.host, function(err) {
//         if (err) {
//           throw err;
//         }
//         console.log(`Ready! Open ${this.hostUrl}`);
//       });
//     }
  }

  // checkToken(req, res, next) {
  //   if (req.query.eg) {
  //     req.session.eg = req.query.eg; // Save the requested example number
  //   }
  //   // Do we have a token that can be used?
  //   // Use a 30 minute buffer time to enable the user to fill out
  //   // a request form and send it.
  //   let tokenBufferMin = 30,
  //     now = moment();
  //   if (
  //     tokenBufferMin &&
  //     req.user &&
  //     req.user.accessToken &&
  //     now.add(tokenBufferMin, "m").isBefore(req.user.expires)
  //   ) {
  //     console.log("\nUsing existing access token.");
  //     next();
  //   } else {
  //     console.log("\nGet a new access token.");
  //     res.redirect("/auth");
  //   }
  // }

  // dsLoginCB1(req, res, next) {
  //   passport.authenticate("docusign", { failureRedirect: "/auth" })(
  //     req,
  //     res,
  //     next
  //   );
  // }

  // dsLoginCB2(req, res, next) {
  //   console.log(
  //     `Received access_token: ${req.user.accessToken.substring(0, 15)}...`
  //   );
  //   console.log(
  //     `Expires at ${req.user.expires.format("dddd, MMMM Do YYYY, h:mm:ss a")}`
  //   );
  //   // If an example was not requested, redirect to home
  //   if (req.session.eg) {
  //     res.redirect("/go");
  //   } else {
  //     res.redirect("/");
  //   }
  // }

  // goPageController(req, res, next) {
  //   // getting the API client ready
  //   this.apiClient = new docusign.ApiClient();
  //   this.apiClient.addDefaultHeader(
  //     "Authorization",
  //     "Bearer " + req.user.accessToken
  //   );

  //   // The DocuSign Passport strategy looks up the user's account information via OAuth::userInfo.
  //   // See https://developers.docusign.com/esign-rest-api/guides/authentication/user-info-endpoints
  //   // We want the user's account_id, account_name, and base_uri
  //   // A user can (and often) belongs to multiple accounts.
  //   // You can search for a specific account the user has, or
  //   // give the user the choice of account to use, or use
  //   // the user's default account. This example used the default account.
  //   //
  //   // The baseUri changes rarely so it can (and should) be cached.
  //   //
  //   // req.user holds the result of DocuSign OAuth::userInfo and tokens.
  //   this.getDefaultAccountInfo(req.user.accounts);
  //   this.apiClient.setBasePath(this.baseUri); // baseUri is specific to the account
  //   docusign.Configuration.default.setDefaultApiClient(this.apiClient);
  //   // Execute an example.
  //   this.eg = req.session.eg; // retrieve the requested example number
  //   req.session.eg = false; // reset

  //   Promise.resolve()
  //     // Send an envelope via email
  //     .then(
  //       result => (this.eg == 1 ? this.createEnvelope(this.accountId) : result)
  //     )
  //     // Embedded signing example (create Recipient View)
  //     .then(result => {
  //       let prefix = "<h2>Results:</h2><p>",
  //         suffix = '</p><h2><a href="/">Continue</a></h2';
  //       // Save the envelopeId for later use:
  //       if (result.envelopeId) {
  //         req.session.sentEnvelopeId = result.envelopeId;
  //       }
  //       if (result.redirect) {
  //         res.redirect(result.redirect);
  //       } else {
  //         res.send(`${prefix} ${result.msg} ${suffix}`);
  //       }
  //     });
  // }

  // dsPingController(req, res) {
  //   // This function is called periodically via AJAX from the
  //   // DocuSign Signing Ceremony. The AJAX calls include cookiers and
  //   // will keep our session fresh.
  //   // Any return values are ignored.
  //   console.log("\nDocuSign PING received.");
  //   res.send();
  // }

  // getDefaultAccountInfo(accounts) {
  //   let defaultAccount = accounts.find(item => item.is_default);
  //   console.log(
  //     `Default account "${defaultAccount.account_name}" (${
  //       defaultAccount.account_id
  //     })`
  //   );
  //   this.accountId = defaultAccount.account_id;
  //   this.baseUri = `${defaultAccount.base_uri}${this.baseUriSuffix}`;
  // }

  // make_promise(obj: any, method_name: any) {
  //   let promise_name = method_name + "_promise";
  //   if (!(promise_name in obj)) {
  //     obj[promise_name] =obj[method_name];
  //   }
  //   return obj[promise_name];
  // }

  // createEnvelope(accountId) {
  //   // Create a byte array that will hold our document bytes
  //   let fileBytes, file2Bytes;
  //   try {
  //     // read document file
  //     fileBytes = fs.readFileSync(
  //       path.resolve(__dirname, this.testDocumentPath)
  //     );
  //     file2Bytes = fs.readFileSync(
  //       path.resolve(__dirname, this.test2DocumentPath)
  //     );
  //   } catch (ex) {
  //     // handle error
  //     console.log("Exception while reading file: " + ex);
  //   }

  //   // Create an envelope that will store the document(s), field(s), and recipient(s)
  //   let envDef = new docusign.EnvelopeDefinition();
  //   envDef.emailSubject = "Please sign this document sent from Node SDK";

  //   // Add a document to the envelope.
  //   // This code uses a generic constructor:
  //   let doc = new docusign.Document(),
  //     doc2 = new docusign.Document(),
  //     base64Doc = Buffer.from(fileBytes).toString("base64"),
  //     base64Doc2 = Buffer.from(file2Bytes).toString("base64");
  //   doc.documentBase64 = base64Doc;
  //   doc.name = "Agreement 1.pdf"; // can be different from actual file name
  //   doc.fileExtension = "pdf";
  //   doc.documentId = "1";
  //   doc2.documentBase64 = base64Doc2;
  //   doc2.name = "Battle plan"; // can be different from actual file name
  //   doc2.fileExtension = "docx"; // source document type. It will be converted to pdf
  //   doc2.documentId = "2";

  //   // Add to the envelope. Envelopes can have multiple docs, so an array is used
  //   envDef.documents = [doc, doc2];

  //   // Add a recipient to sign the document, identified by name and email
  //   // Objects for the SDK can be constructed from an object:
  //   let signer = docusign.Signer.constructFromObject({
  //     email: this.signerEmail,
  //     name: this.signerName,
  //     recipientId: "1",
  //     routingOrder: "1"
  //   });

  //   // Both test documents include an "anchor string" of "/sn1/" in
  //   // white text. So we create Sign Here
  //   // fields in the documents, anchored at the string's location.
  //   // The offset is used to position the field correctly in the
  //   // document.
  //   let signHere = docusign.SignHere.constructFromObject({
  //     anchorString: "/sn1/",
  //     anchorYOffset: "10",
  //     anchorUnits: "pixels",
  //     anchorXOffset: "20"
  //   });

  //   // A signer can have multiple tabs, so an array is used
  //   let signHereTabs = [signHere],
  //     tabs = docusign.Tabs.constructFromObject({
  //       signHereTabs: signHereTabs
  //     });
  //   signer.tabs = tabs;

  //   // Add recipients (in this case a single signer) to the envelope
  //   envDef.recipients = new docusign.Recipients();
  //   envDef.recipients.signers = [signer];

  //   // Send the envelope by setting |status| to "sent". To save as a draft set to "created"
  //   envDef.status = "sent";

  //   // instantiate a new EnvelopesApi object
  //   var envelopesApi = new docusign.EnvelopesApi();

  //   // call the createEnvelope() API to create and send the envelope
  //   // The createEnvelope() API is async and uses a callback
  //   // Promises are more convenient, so we promisfy it.
  //   let createEnvelope_promise = this.make_promise(
  //     envelopesApi,
  //     "createEnvelope"
  //   );
  //   return createEnvelope_promise(accountId, { envelopeDefinition: envDef })
  //     .then(result => {
  //       let msg = `\nCreated the envelope! Result: ${JSON.stringify(result)}`;
  //       console.log(msg);
  //       return { msg: msg, envelopeId: result.envelopeId };
  //     })
  //     .catch(err => {
  //       // If the error is from DocuSign, the actual error body is available in err.response.body
  //       let errMsg =
  //           err.response &&
  //           err.response.body &&
  //           JSON.stringify(err.response.body),
  //         msg = `\nException while creating the envelope! Result: ${err}`;
  //       if (errMsg) {
  //         msg += `. API error message: ${errMsg}`;
  //       }
  //       console.log(msg);
  //       return { msg: msg };
  //     });
  // }

  init() {
    let time = moment().format();
    console.log(time);
  }
}



// WEBPACK FOOTER //
// ./src/providers/docusign/docusign.ts